/**
 * Shared award-decision terminology and configuration. Centralised so the
 * "Not Awarded" wording can never drift to "Declined" (PRO-572 hard
 * requirement) and the upload/validation rules stay consistent across drawers.
 */

/** User-facing label for the unsuccessful decision. NEVER "Declined". */
export const NOT_AWARDED_LABEL = "Not Awarded";
export const MARK_NOT_AWARDED_LABEL = "Mark Not Awarded";
export const AWARD_LABEL = "Award";

export const CONFIRM_DECISION_TITLE = "This decision is final";
export const CONFIRM_DECISION_BODY =
	"Award decisions cannot be undone once confirmed. Suppliers will be notified by email. Are you sure you want to continue?";

// Error helpers live at feature level (utils/awardErrors) so the mutation hooks
// can share them; re-exported here for the drawers that already import from this
// module.
export {
	AWARD_DECISION_FINAL_CODE,
	getAwardErrorCode,
	isAwardDecisionFinal,
} from "../../../utils/awardErrors";

/** Max length of the optional decision reason (matches the `comment` rule). */
export const REASON_MAX_LENGTH = 10000;

/** Contract upload — accepted extensions and size cap (client-side, F4). */
export const CONTRACT_ACCEPTED_EXTENSIONS = ["pdf", "doc", "docx"] as const;
export const CONTRACT_MAX_SIZE_MB = 50;
